import adultHeartHigh from '#assets/images/gutBodyConnections/low-quality/adult/heart-high.webp';
import adultHeartLow from '#assets/images/gutBodyConnections/low-quality/adult/heart-low.webp';
import adultHeartModerate from '#assets/images/gutBodyConnections/low-quality/adult/heart-moderate.webp';
import intestinesUterusFullHigh from '#assets/images/gutBodyConnections/low-quality/adult/intestines-uterus-full-high.webp';
import intestinesUterusFullLow from '#assets/images/gutBodyConnections/low-quality/adult/intestines-uterus-full-low.webp';
import intestinesUterusFullModerate from '#assets/images/gutBodyConnections/low-quality/adult/intestines-uterus-full-moderate.webp';
import adultKidneyHigh from '#assets/images/gutBodyConnections/low-quality/adult/kidney-high.webp';
import adultKidneyLow from '#assets/images/gutBodyConnections/low-quality/adult/kidney-low.webp';
import adultKidneyModerate from '#assets/images/gutBodyConnections/low-quality/adult/kidney-moderate.webp';
import adultLiverHigh from '#assets/images/gutBodyConnections/low-quality/adult/liver-high.webp';
import adultLiverLow from '#assets/images/gutBodyConnections/low-quality/adult/liver-low.webp';
import adultLiverModerate from '#assets/images/gutBodyConnections/low-quality/adult/liver-moderate.webp';
import adultLungsHigh from '#assets/images/gutBodyConnections/low-quality/adult/lungs-high.webp';
import adultLungsLow from '#assets/images/gutBodyConnections/low-quality/adult/lungs-low.webp';
import adultLungsModerate from '#assets/images/gutBodyConnections/low-quality/adult/lungs-moderate.webp';
import adultMusculoskeletalHigh from '#assets/images/gutBodyConnections/low-quality/adult/musculoskeletal-high.webp';
import adultMusculoskeletalLow from '#assets/images/gutBodyConnections/low-quality/adult/musculoskeletal-low.webp';
import adultMusculoskeletalModerate from '#assets/images/gutBodyConnections/low-quality/adult/musculoskeletal-moderate.webp';
import fetusHigh from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/fetus-high.webp';
import fetusLow from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/fetus-low.webp';
import fetusModerate from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/fetus-moderate.webp';
import intestinesBabyFullHigh from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-baby-full-high.webp';
import intestinesBabyFullLow from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-baby-full-low.webp';
import intestinesBabyFullModerate from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-baby-full-moderate.webp';
import intestinesWithBabyHigh from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-with-baby-high.webp';
import intestinesWithBabyLow from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-with-baby-low.webp';
import intestinesWithBabyModerate from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-with-baby-moderate.webp';
import adultThyroidHigh from '#assets/images/gutBodyConnections/low-quality/adult/thyroid-high.webp';
import adultThyroidLow from '#assets/images/gutBodyConnections/low-quality/adult/thyroid-low.webp';
import adultThyroidModerate from '#assets/images/gutBodyConnections/low-quality/adult/thyroid-moderate.webp';
import uterusHigh from '#assets/images/gutBodyConnections/low-quality/adult/uterus-high.webp';
import uterusLow from '#assets/images/gutBodyConnections/low-quality/adult/uterus-low.webp';
import uterusModerate from '#assets/images/gutBodyConnections/low-quality/adult/uterus-moderate.webp';
import paediatricLungsHigh from '#assets/images/gutBodyConnections/low-quality/paediatric/lungs-high.webp';
import paediatricLungsLow from '#assets/images/gutBodyConnections/low-quality/paediatric/lungs-low.webp';
import paediatricLungsModerate from '#assets/images/gutBodyConnections/low-quality/paediatric/lungs-moderate.webp';
import brainHigh from '#assets/images/gutBodyConnections/low-quality/shared/brain-high.webp';
import brainLow from '#assets/images/gutBodyConnections/low-quality/shared/brain-low.webp';
import brainModerate from '#assets/images/gutBodyConnections/low-quality/shared/brain-moderate.webp';
import intestinesFullHigh from '#assets/images/gutBodyConnections/low-quality/shared/intestines-full-high.webp';
import intestinesFullLow from '#assets/images/gutBodyConnections/low-quality/shared/intestines-full-low.webp';
import intestinesFullModerate from '#assets/images/gutBodyConnections/low-quality/shared/intestines-full-moderate.webp';
import intestinesHigh from '#assets/images/gutBodyConnections/low-quality/shared/intestines-high.webp';
import intestinesLow from '#assets/images/gutBodyConnections/low-quality/shared/intestines-low.webp';
import intestinesModerate from '#assets/images/gutBodyConnections/low-quality/shared/intestines-moderate.webp';
import stomachFullHigh from '#assets/images/gutBodyConnections/low-quality/shared/stomach-full-high.webp';
import stomachFullLow from '#assets/images/gutBodyConnections/low-quality/shared/stomach-full-low.webp';
import stomachFullModerate from '#assets/images/gutBodyConnections/low-quality/shared/stomach-full-moderate.webp';
import stomachHigh from '#assets/images/gutBodyConnections/low-quality/shared/stomach-high.webp';
import stomachLow from '#assets/images/gutBodyConnections/low-quality/shared/stomach-low.webp';
import stomachModerate from '#assets/images/gutBodyConnections/low-quality/shared/stomach-moderate.webp';

import adultHeartPurple from '#assets/images/gutBodyConnections/low-quality/adult/heart-purple.webp';
import adultKidneyPurple from '#assets/images/gutBodyConnections/low-quality/adult/kidney-purple.webp';
import adultLiverPurple from '#assets/images/gutBodyConnections/low-quality/adult/liver-purple.webp';
import adultLungsPurple from '#assets/images/gutBodyConnections/low-quality/adult/lungs-purple.webp';
import adultMetabolicPurple from '#assets/images/gutBodyConnections/low-quality/adult/metabolic-purple.webp';
import adultMusculoskeletalPurple from '#assets/images/gutBodyConnections/low-quality/adult/musculoskeletal-purple.webp';
import adultThyroidPurple from '#assets/images/gutBodyConnections/low-quality/adult/thyroid-purple.webp';
import brainPurple from '#assets/images/gutBodyConnections/low-quality/shared/brain-purple.webp';
import fetusPurple from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/fetus-purple.webp';
import intestinesBabyFullPurple from '#assets/images/gutBodyConnections/low-quality/adult/pregnant/intestines-baby-full-purple.webp';
import intestinesFullPurple from '#assets/images/gutBodyConnections/low-quality/shared/intestines-full-purple.webp';
import intestinesPurple from '#assets/images/gutBodyConnections/low-quality/shared/intestines-purple.webp';
import intestinesUterusFullPurple from '#assets/images/gutBodyConnections/low-quality/adult/intestines-uterus-full-purple.webp';
import paediatricLungsPurple from '#assets/images/gutBodyConnections/low-quality/paediatric/lungs-purple.webp';
import stomachFullPurple from '#assets/images/gutBodyConnections/low-quality/shared/stomach-full-purple.webp';
import stomachPurple from '#assets/images/gutBodyConnections/low-quality/shared/stomach-purple.webp';
import uterusPurple from '#assets/images/gutBodyConnections/low-quality/adult/uterus-purple.webp';

import { HIGH_QUALITY_ARTWORK } from '../high-quality';
import type { OrganArtworkSet } from '../types';

/** The high-quality drawings capped at 300px: the PDF embeds images at full resolution.
 * The SVG organs are vector, so they are shared as they are. */
export const LOW_QUALITY_ARTWORK: OrganArtworkSet = {
  ...HIGH_QUALITY_ARTWORK,
  metabolic: {
    ...HIGH_QUALITY_ARTWORK.metabolic,
    purple: adultMetabolicPurple,
  },
  brain: {
    low: brainLow,
    moderate: brainModerate,
    high: brainHigh,
    purple: brainPurple,
  },
  endocrine: {
    low: adultThyroidLow,
    moderate: adultThyroidModerate,
    high: adultThyroidHigh,
    purple: adultThyroidPurple,
  },
  heart: {
    low: adultHeartLow,
    moderate: adultHeartModerate,
    high: adultHeartHigh,
    purple: adultHeartPurple,
  },
  kidney: {
    low: adultKidneyLow,
    moderate: adultKidneyModerate,
    high: adultKidneyHigh,
    purple: adultKidneyPurple,
  },
  liver: {
    low: adultLiverLow,
    moderate: adultLiverModerate,
    high: adultLiverHigh,
    purple: adultLiverPurple,
  },
  muscle: {
    low: adultMusculoskeletalLow,
    moderate: adultMusculoskeletalModerate,
    high: adultMusculoskeletalHigh,
    purple: adultMusculoskeletalPurple,
  },
  paediatricLungs: {
    low: paediatricLungsLow,
    moderate: paediatricLungsModerate,
    high: paediatricLungsHigh,
    purple: paediatricLungsPurple,
  },
  adultLungs: {
    low: adultLungsLow,
    moderate: adultLungsModerate,
    high: adultLungsHigh,
    purple: adultLungsPurple,
  },
  gut: {
    low: intestinesLow,
    moderate: intestinesModerate,
    high: intestinesHigh,
    purple: intestinesPurple,
  },
  gutFull: {
    low: intestinesFullLow,
    moderate: intestinesFullModerate,
    high: intestinesFullHigh,
    purple: intestinesFullPurple,
  },
  gutUterusFull: {
    low: intestinesUterusFullLow,
    moderate: intestinesUterusFullModerate,
    high: intestinesUterusFullHigh,
    purple: intestinesUterusFullPurple,
  },
  gutBabyFull: {
    low: intestinesBabyFullLow,
    moderate: intestinesBabyFullModerate,
    high: intestinesBabyFullHigh,
    purple: intestinesBabyFullPurple,
  },
  gutWithBaby: {
    low: intestinesWithBabyLow,
    moderate: intestinesWithBabyModerate,
    high: intestinesWithBabyHigh,
  },
  stomach: {
    low: stomachLow,
    moderate: stomachModerate,
    high: stomachHigh,
    purple: stomachPurple,
  },
  stomachFull: {
    low: stomachFullLow,
    moderate: stomachFullModerate,
    high: stomachFullHigh,
    purple: stomachFullPurple,
  },
  fetus: {
    low: fetusLow,
    moderate: fetusModerate,
    high: fetusHigh,
    purple: fetusPurple,
  },
  uterus: {
    low: uterusLow,
    moderate: uterusModerate,
    high: uterusHigh,
    purple: uterusPurple,
  },
};
